import { render, staticRenderFns } from "./OrdersPipelinesEnabled.vue?vue&type=template&id=a54ae1c0&"
import script from "./OrdersPipelinesEnabled.vue?vue&type=script&lang=ts&"
export * from "./OrdersPipelinesEnabled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports